/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { EDIT_APPLICATION_FORM } from "../pages/NewEpccApplication/graphql";
import { toast } from "react-hot-toast"

const MODULE_NAME = "ApplicationFormService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ApplicationFormService {
    private static instance: ApplicationFormService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ApplicationFormService {
        if (!ApplicationFormService.instance) {
            ApplicationFormService.instance = new ApplicationFormService(props);
        }
        return ApplicationFormService.instance;
    }


    async  editApplicationForm(props:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }
        console.log(props);
        console.log('ApplicationFormService()::editApplicationForm()-> entered here..');

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_APPLICATION_FORM,
                    variables: {
                        input:props
                    },

                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "editApplicationForm : ", res?.data);
                if (res) {
                    return res?.data?.createApplication;
                }
            }
        } catch (err: any) {
            console.log(err)
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
